import tools from '@/tools';

var paramObj = tools.param2Obj(window.location.href);

var global = {
    topicId: paramObj.id || '5a20c416cc1193a82500002a',
    platformId: paramObj.platform || '5a12478e931c750f008b4568'
}

export default global;



// WEBPACK FOOTER //
// ./src/global/index.js